import {
  GET_SHORTLIST_DETAILS,
  GET_SHORTLIST_DETAILS_SUCCESS,
  GET_SHORTLIST_DETAILS_FAIL,
  GET_SHORTLIST_MANAGERS_LIST,
  GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
  GET_SHORTLIST_MANAGERS_LIST_FAILED,
  ADD_SHORTLIST_MANAGER_SUCCESS,
  ADD_SHORTLIST_MANAGER_FAILURE,
  UPDATE_SHORTLIST_DETAILS,
  UPDATE_SHORTLIST_DETAILS_SUCCESS,
  UPDATE_SHORTLIST_DETAILS_FAIL,
} from "./actionTypes";
const initialState = {
  errorMessage: null,
  successMessage: null,
  loader: false,
  shortlistDetails: {},
  shortlistDetailsError: null,
};

const ShortlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHORTLIST_DETAILS:
      state = {
        ...state,
        loader: true,
        shortlistDetailsError: null,
        shortlistDetails: null,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case GET_SHORTLIST_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        shortlistDetails: action.payload,
        shortlistDetailsError: null,
      };
      break;
    case GET_SHORTLIST_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        shortlistDetails: null,
        shortlistDetailsError: action.payload,
      };
      break;
    case GET_SHORTLIST_MANAGERS_LIST:
      state = {
        ...state,
        // loader: true,
        shorlistManagerList: null,
        errorMessage: null,
      };
      break;

    case GET_SHORTLIST_MANAGERS_LIST_SUCCESS:
      state = {
        ...state,
        //loader: false,
        shorlistManagerList: action.payload,
        errorMessage: null,
      };
      break;
    case GET_SHORTLIST_MANAGERS_LIST_FAILED:
      state = {
        ...state,
        //loader: false,
        shorlistManagerList: null,
        errorMessage: action.payload,
      };
      break;
    case ADD_SHORTLIST_MANAGER_SUCCESS:
      state = {
        ...state,
        loader: false,
        successMessage: action.payload,
        errorMessage: null,
      };
      break;

    case ADD_SHORTLIST_MANAGER_FAILURE:
      state = {
        ...state,
        loader: false,
        successMessage: null,
        errorMessage: action.payload,
      };
      break;

    case UPDATE_SHORTLIST_DETAILS:
      state = {
        ...state,
        loader: true,
        updateShortlistSuccess: null,
        updateShortlistError: null,
      };
      break;

    case UPDATE_SHORTLIST_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        updateShortlistSuccess: action.payload,
        updateShortlistError: null,
      };
      break;

    case UPDATE_SHORTLIST_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        updateShortlistSuccess: null,
        updateShortlistError: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};
export default ShortlistReducer;
